package com.patronat.top.utils

import androidx.compose.runtime.Composable
import androidx.compose.runtime.DisposableEffect
import androidx.compose.runtime.remember
import com.arkivanov.decompose.ComponentContext
import com.arkivanov.decompose.DefaultComponentContext
import com.arkivanov.essenty.lifecycle.LifecycleRegistry
import com.arkivanov.essenty.lifecycle.resume
import com.arkivanov.essenty.lifecycle.stop

@Composable
fun <T> rememberRetainedComponent(factory: (ComponentContext) -> T): T {
    val lifecycle = remember { LifecycleRegistry() }
    val componentContext = remember { DefaultComponentContext(lifecycle) }

    DisposableEffect(Unit) {
        lifecycle.resume()
        onDispose { lifecycle.stop() }
    }

    return remember { factory(componentContext) }
}